import EventEmitter from 'events';

class ResponsiveManagerClass extends EventEmitter {
    constructor() {
        super();

        this.device = 'md'
    }

    setDevice(device){
        this.device = device;

        this.emit('change');
    }
}

const ResponsiveManager = new ResponsiveManagerClass;


export default ResponsiveManager;


// WEBPACK FOOTER //
// ./src/helpers/ResponsiveManager.js